<template>
    <div class="list">
        <div class="userSetting">

        <h1 class="topTitle">商品コピー</h1>
        <div class="container">
            <div class="item-wrap">
                <table class="itemTable">
                    <tr>
                        <th class="listTitle">
                            コピー元
                        </th>
                        <th class="listTitle">
                            コピー先
                        </th>
                        <th class="listTitle">
                            更新
                        </th>
                    </tr>
                    <tr>
                        <td class="listItem">
                            <select class="sltBox" v-model="postItem.baseId" @change="getItem">
                                <option value="" disabled selected hidden>選択してください</option>
                                <option v-for="item in tmpUserList" :value="item.USER_ID" :key="item.USER_ID">
                                    {{ item.USER_NAME }}
                                </option>
                            </select>
                        </td>
                        <td class="listItem">
                            <select class="sltBox" v-model="postItem.copyId">
                                <option value="" disabled selected hidden>選択してください</option>
                                <option v-for="item in tmpUserList" :value="item.USER_ID" :key="item.USER_ID">
                                    {{ item.USER_NAME }}
                                </option>
                            </select>
                        </td>
                        <td class="listItem">
                            <div class="remBox"><span class="remText">選択したユーザーへ<br>商品情報をコピーします。</span><button class="btn remove" @click="copy()">商品情報を全てコピーする</button></div>
                        </td>
                    </tr>
                    <div class="none">
                    <input type="text" v-model="tmpLogin">
                </div>
                </table>
                </div>

                <div class="item-wrap" style="padding-top:100px;">
                <table class="itemTable">
                    <tr>
                        <th class="listTitle">
                            チェック
                        </th>
                        <th class="listTitle">
                            商品画像
                        </th>
                        <th class="listTitle">
                            商品名
                        </th>
                    </tr>
                    
                    <tr v-for="(item, index) in itemList" :key="item.ITEM_ID" >
                        <td>
                            <input type="checkbox" v-model="item.check" :id="index + '_check'" />
                            <label class="checkbox03" :for="index + '_check'"></label>
                        </td>
                        <td class="listItem center imgF">
                            <img v-show ="item.ITEM_IMG1 != null" class="itemImg" :src="item.ITEM_IMG1">
                            <img v-show ="item.ITEM_IMG1 == null" class="itemImg" src="../assets/noimage.jpg">
                        </td>
                        <td class="listItem">
                            {{item.ITEM_TITLE}}
                        </td>
                        
                    </tr>
                    <div class="none">
                        <input type="text" v-model="tmp">
                    </div>
                    
                </table>
                </div>
            <div class="btnBox subArea">
                <button class="btn repage" @click="returnPage">戻る</button>
                <button class="btn submit" @click="checkItemCopy" >チェックした商品情報のみコピーする</button>
            </div>
        </div>
    </div>
    </div>
</template>
<script>

import {userRepository} from '@/Repositories/userRepository.js'

import {copyItemRepository} from '@/Repositories/copyItemRepository.js'
export default {
    
  data() {
        return {
            itemList:[],
            userInfo:{},
            userList:[],
            tmpUserList:[],
            tmpLogin:'',
            tmp:'',
            isModal:false,
            postItem:{
                baseId:'',
                copyId:''
            }
        }
  },
  methods:{
      getItem(){
          let vm = this;
          copyItemRepository.methods.getItem(vm.postItem.baseId)
            .then(res=>{
                vm.itemList = res.data; 
            })
            .catch(err=>{
                console.log(err);
            })
      },
      copy(){
          let vm = this;
          var userName = this.tmpUserList.filter((x)=>{
            return x.USER_ID == vm.postItem.copyId;
          })[0].USER_NAME;
          
          console.log(userName);
          vm.$functions.swAlert(vm, "warning", "このユーザーへ商品情報をコピーしてよろしいですか？", `ユーザー名:${userName}`)
            .then((btn) => {
            if (btn.isConfirmed) {
                copyItemRepository.methods.copy(vm.postItem)
                .then(res=>{
                    this.$swal("コピーしました", {
                        icon: "success",
                    }).then(res=>{vm.$functions.reload(vm)});
                })
            }
        });
          
      },
      checkItemCopy(){
          var items = this.itemList.filter(function(item){
              return item.check;
          }).map(item => item.ITEM_ID);

          var post = {
              ITEM_IDS:items,
              USER_ID:this.postItem.copyId
          };
          copyItemRepository.methods.checkCopy(post)
            .then(res=>{
                this.$swal("コピーしました", {
                    icon: "success",
                }).then(res=>{vm.$functions.reload(vm)});
            })
      },
      returnPage(){
          let vm = this;
            vm.$router.back();
        },
        init(){
            let vm =this;
            vm.userInfo = vm.$functions.getSStorage('userInfo');
            userRepository.methods.getAdmin()
            .then(res=>{
                var data = res.data;
                for(var i=0; i< data.length; i++){
                    data[i].tmpPassword = '';
                    data[i].display = true;
                }
                vm.tmpUserList = data;
            })
            .catch(err=>{
                console.log(err);
            })
        },
  },
  created:function(){
      let vm =this;
      vm.init();
  }
  
}
</script>

<style scoped lang="scss">
    @import "../style/menu.scss";
    @import "../style/list.scss";
    @import "../style/userSetting.scss";
    @import "../style/login.scss";
    select.sltBox {
        width: 100%;
    }
    .item-wrap {
        overflow: hidden;
    }
</style>